import { render, staticRenderFns } from "./PhonenumberComponent.vue?vue&type=template&id=30b3fe0b&"
import script from "./PhonenumberComponent.vue?vue&type=script&lang=js&"
export * from "./PhonenumberComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports